export default __webpack_public_path__ + "static/media/btn-point-20.14db9c8c.svg";